import { h, Component } from 'preact';

import style from '../../style/footer.sass';
import ContentHandler from '../util/contentHandler.js';

const getFooterStyleClassNames = (brand) => {
  if(brand === 'rheem'){
    return {
      container: style.container,
    };
  }
  if(brand === 'ruud'){
    return {
      container: style.containerRuud,
    };
  }
  if(brand === 'friedrich'){
    return {
      container: style.containerFriedrich,
    };
  }
  return {
    container: style.container,
  };
};

class Disclaimers extends Component {
  render(props){
    const contentHandler = new ContentHandler();
    const brandName = props.brand.charAt(0).toUpperCase() + props.brand.substring(1);
    const disclaimerItems = [];
    if(props.campaignType === 'repair'){
      disclaimerItems.push(<li>&nbsp;</li>);
    }else{
      if(props.brand !== 'friedrich'){
        disclaimerItems.push(<li><sup>1</sup>Efficiency claim based on the {contentHandler.titleCase(props.brand)} RP20 heat pump rated at 13 HSPF/20 SEER compared to a standard heat pump rated at 8.2 HSPF/13 SEER. Percentages are based on national averages; may vary according to installation.</li>);
        disclaimerItems.push(<li><sup>2</sup>Efficiency claim based on the {contentHandler.titleCase(props.brand)} RA20 air conditioner rated at 20 SEER compared to a traditional 13 SEER air conditioner. Percentages are based on national averages; may vary according to installation.</li>);
        disclaimerItems.push(<li><sup>3</sup>On your KwikComfort<sup>&reg;</sup> Financing credit card. Subject to credit approval. Minimum monthly payments required. See contractor for details.</li>);
        disclaimerItems.push(<li><sup>4</sup> Consult a tax professional regarding your individual tax situation and ability to claim a tax credit related to the purchase of qualifying {brandName} products; Visit energystar.gov for more details.</li>);
      }
      disclaimerItems.push(<li><sup>*</sup>ENERGY STAR<sup>&reg;</sup> compliant in certain matched systems. See applicable specification sheets on {props.brand}.com for further details. Proper sizing and installation of equipment is critical to achieve optimal performance. Split system air conditioners and heat pumps must be matched with appropriate coil components to meet ENERGY STAR<sup>&reg;</sup> requirements. Ask your contractor for details or visit. www.energystar.gov</li>);
    }
    return (
      <ul className={style.disclaimers}>
        {disclaimerItems}
      </ul>
    )
  }
}

export default class Footer extends Component {
  render(props) {
    const classNames = getFooterStyleClassNames(props.brand);
    return (
      <div id="footer" className={classNames.container}>
        <Disclaimers {...props} />
      </div>
    );
  }
}